export const documentsTexts = {
  collections: {
    title: "Colecciones de Documentos",
    buttonText: "Revisar Documentación",
    collections: [
      {
        id: 1,
        name: 'Normas de Construcción Chilena',
        description: 'Regulaciones y estándares de construcción edificatoria que aseguran la seguridad, calidad y cumplimiento legal en proyectos. Incluye normativas sísmicas, eléctricas, sanitarias y códigos de edificación actualizados según las últimas disposiciones técnicas.',
        source: '/source',
        icon: 'BusinessIcon',
        link: '/dashboard',
        suggestedQuestions: [
          '¿Cuáles son los requisitos para postular a un subsidio?',
          '¿Cómo puedo actualizar mis datos en el sistema?',
          '¿Qué documentos necesito para una fiscalización?',
          '¿Cuáles son los horarios de atención presencial?',
          '¿Cómo puedo contactar a un representante?'
        ]
      },
      {
        id: 2,
        name: 'Documentación Aduanera Chilena',
        description: 'Incluye las Declaraciones de Ingreso (DIN) y de Salida (DUS), junto con estadísticas e informes sobre comercio exterior y recaudación.',
        source: '/source',
        icon: 'DirectionsBoatIcon',
        link: '/dashboard',
        suggestedQuestions: [
          '¿Qué documentos necesito para importar mercancías?',
          '¿Cómo funciona el proceso de declaración aduanera?',
          '¿Cuáles son los requisitos para exportar productos?',
          '¿Qué impuestos aplican a las importaciones?',
          '¿Cómo puedo consultar el estado de mi declaración?'
        ]
      },
      {
        id: 3,
        name: 'Documentación Técnica del SII',
        description: 'Agrupa todos los manuales e instructivos técnicos del SII, Nuestra plataforma reúne los principales documentos técnicos del SII para facturación electrónica: el Instructivo de emisión de DTE; los Libros Electrónicos de Compras y Ventas; y el Catálogo de Esquemas Tributarios, con códigos y configuraciones vigentes para impuestos y exenciones.',
        source: '/source',
        icon: 'AssuredWorkloadIcon',
        link: '/dashboard',
        suggestedQuestions: [
          '¿Cómo emitir una factura electrónica correctamente?',
          '¿Qué códigos de impuestos debo usar?',
          '¿Cómo registrar compras y ventas en los libros electrónicos?',
          '¿Qué hacer si tengo un error en la facturación?',
          '¿Cómo actualizar mi información tributaria?'
        ]
      }
    ]
  },
  dashboard: {
    title: "Normas de Construcción Chilena",
    search: {
      placeholder: "Búsqueda textual o semántica..."
    },
    stats: [
      { 
        title: 'Fuentes y Documentos', 
        value: 125, 
        icon: 'ArticleIcon', 
        color: 'primary.main' 
      },
      { 
        title: 'Entidades', 
        value: 135, 
        icon: 'MenuBookIcon', 
        color: 'secondary.main' 
      },
      { 
        title: 'Segmentos', 
        value: 1843, 
        icon: 'ContentCutIcon', 
        color: 'primary.dark' 
      }
    ],
    documentsTable: {
      title: "Base de Contextual",
      headers: {
        title: "Título",
        source: "Fuente",
        link: "Link"
      },
      documents: [
        { title: 'NCh 433 - Diseño Sísmico de Edificios', source: 'Normas de Construcción Chilena', link: '/source' },
        { title: 'NCh 2369 - Diseño Sísmico de Estructuras e Instalaciones Industriales', source: 'Normas de Construcción Chilena', link: '/source' },
        { title: 'Política de Seguridad de Datos', source: 'Políticas de Seguridad', link: '/source' },
        { title: 'Protocolo de Respuesta a Incidentes', source: 'Políticas de Seguridad', link: '/source' },
        { title: 'Manual de Estilo de Código', source: 'Guías de Estilo', link: '/source' },
        { title: 'Guía de Nomenclatura de Archivos', source: 'Guías de Estilo', link: '/source' },
        { title: 'NCh 1537 - Diseño de Hormigón Armado', source: 'Normas Estructurales', link: '/source' },
        { title: 'NFPA 101 - Código de Seguridad Humana', source: 'Reglamentos Contra Incendio', link: '/source' },
        { title: 'DS 50 - Reglamento de Instalaciones Sanitarias', source: 'Instalaciones Sanitarias', link: '/source' },
        { title: 'IEC 60364 - Instalaciones Eléctricas de Edificios', source: 'Código Eléctrico', link: '/source' },
        { title: 'ASHRAE 90.1 - Eficiencia Energética', source: 'Eficiencia Energética', link: '/source' },
        { title: 'NCh 135 - Ensaye de Materiales', source: 'Especificaciones de Materiales', link: '/source' },
        { title: 'ISO 14001 - Gestión Ambiental', source: 'Normas Ambientales', link: '/source' },
        { title: 'Ordenanza General de Urbanismo y Construcciones (OGUC)', source: 'Planificación Urbana', link: '/source' },
        { title: 'Guía de Reforzamiento Sísmico', source: 'Reforzamiento Sísmico', link: '/source' },
        { title: 'NCh 290 - Gestión de Calidad en Obras', source: 'Aseguramiento de Calidad', link: '/source' },
        { title: 'DS 594 - Condiciones Sanitarias en el Trabajo', source: 'Seguridad Laboral', link: '/source' },
        { title: 'ISO 45001 - Seguridad y Salud en el Trabajo', source: 'Seguridad Laboral', link: '/source' },
        { title: 'NCh 3562 - Gestión de Residuos de Construcción', source: 'Gestión de Residuos', link: '/source' },
        { title: 'DS 10 - Reglamento de Calificación Energética', source: 'Eficiencia Energética', link: '/source' }
      ]
    },
    knowledgeGraph: {
      title: "Diagrama de Conocimiento"
    },
    modal: {
      descriptions: {
        'Fuentes y Documentos': 'Cantidad total de documentos disponibles en la plataforma.',
        'Entidades': 'Personas u organizaciones que se pueden relacionar entre si según el contexto seleccionado.',
        'Segmentos': 'Unidades mínimas de contexto de cada documento que representan un pedazo de información que puede ser relevante para la pregunta.',
        'Base de Contextual': 'Lista de documentos disponibles, su colección y link de acceso (si es de acceso público).',
        'Diagrama de Conocimiento': 'Visualización gráfica de las relaciones y conexiones entre los documentos, organizaciones y entidades presentes en los documentos.'
      }
    }
  }
}; 